<script setup>
import UserProfileComponent from "@/Components/UserCard/UserProfileComponent.vue";
import FilesListComponent from "@/Components/Files/FilesListComponent.vue";
import {Permissions} from "@/Utils/Permissions";
import FilesUploadComponent from "@/Components/Files/FilesUploadComponent.vue";
</script>

<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12">
        <UserProfileComponent contextIdA="myprofile"/>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="6" v-if="Permissions.checkPermissions(['files.upload'])">
        <FilesUploadComponent :myProfile="true"/>
      </v-col>
      <v-col cols="6" v-if="Permissions.checkPermissions(['files.list'])">
        <FilesListComponent :myProfile="true"/>
      </v-col>
    </v-row>
  </v-container>
</template>